import { Component, Input } from '@angular/core';
import { SecuredResourceComponent } from './secured-resource.component';

@Component({
  selector: 'miq-secured-link',
  template: `
    <ng-container *ngIf="src$ | async as src; else failureLink">
      <a mat-button [href]="src" [target]="target" [disabled]="disabled">
        <ng-content select="[content]"></ng-content>
      </a>
    </ng-container>

    <ng-template #failureLink>
      <a mat-button class="failure-link">
        <ng-content select="[failure]"></ng-content>
      </a>
    </ng-template>
  `,
  standalone: false,
})
export class SecuredLinkComponent extends SecuredResourceComponent {
  @Input() target = '_self';
  @Input() disabled = false;
  @Input() fileName;
}
